<template>

  <div class="customer-form-holder">

    <h1>{{ t.customer_information }}</h1>
    <form method="post" id="webshop-customer" v-on:submit.prevent>

      <div class="row">
        <div class="col-md-4" v-if="type === '1'">

          <fieldset>

            <legend class="mb-3">{{ t.registration_information }}</legend>

            <div class="form-group">
              <label class="control-label" for="email">{{ t.email }}*</label>
              <input type="text" id="email" class="form-control" name="email"
                     v-model="userData.email"
                     v-bind:class="{ 'is-invalid' : error.email }"
                     @click="setEmail()"
                     @focusout="emailFocusOut">

              <p class="input-error-hint" v-if="error.email" v-html="error.email"></p>
            </div>

            <div class="form-group">
              <label class="control-label" for="password">{{ t.password }}*</label>
              <input type="password" id="password" class="form-control" name="password"
                     v-model="userData.password"
                     v-bind:class="{ 'is-invalid' : error.password }"
                     @focus="error.password = null">

              <p class="input-error-hint" v-if="error.password" v-html="error.password"></p>

            </div>

            <div class="form-group">
              <label class="control-label" for="password_again">{{ t.password_again }}*</label>
              <input type="password" id="password_again" class="form-control" name="password_again"
                     v-model="userData.passwordAgain"
                     v-bind:class="{ 'is-invalid' : error.passwordAgain }"
                     @focus="error.passwordAgain = null">

              <p class="input-error-hint" v-if="error.passwordAgain" v-html="error.passwordAgain"></p>
            </div>

          </fieldset>

          <fieldset>

            <legend class="mb-3">{{ t.contact_information }}</legend>

            <div class="form-group" v-if="!settingData.separatedName">
              <label class="control-label" for="name">{{ t.name }}*</label>
              <input type="text" id="name" class="form-control" name="name"
                     v-model="userData.name"
                     v-bind:class="{ 'is-invalid' : error.name }"
                     @focus="error.name = null"
                     @change="setNames('NAME')">

              <p class="input-error-hint" v-if="error.name" v-html="error.name"></p>
            </div>

            <div class="form-group" v-if="settingData.separatedName">
              <label class="control-label" for="last_name">{{ t.last_name }}*</label>
              <input type="text" id="last_name" class="form-control" name="last_name"
                     v-model="userData.last_name"
                     v-bind:class="{ 'is-invalid' : error.last_name }"
                     @focus="error.last_name = null">

              <p class="input-error-hint" v-if="error.last_name" v-html="error.last_name"></p>
            </div>

            <div class="form-group" v-if="settingData.separatedName">
              <label class="control-label" for="first_name">{{ t.first_name }}*</label>
              <input type="text" id="first_name" class="form-control" name="first_name"
                     v-model="userData.first_name"
                     v-bind:class="{ 'is-invalid' : error.first_name }"
                     @focus="error.first_name = null">

              <p class="input-error-hint" v-if="error.first_name" v-html="error.first_name"></p>
            </div>

            <div class="form-group">
              <label class="control-label" for="phone">{{ t.phone }}*</label>
              <div class="d-flex">
                <div style="border: 1px solid #ced4da;" class="d-flex flex-column">
                  <img style="height: 35px;padding: 8px;" :src="phoneSrc" @click="showPhoneIcons = !showPhoneIcons;"/>
                  <img style="height: 20px;padding: 0 8px;" v-if="showPhoneIcons" @click="setPhonePrefix('HU');userData.phone='+36'" src="/images/hu.png" />
                  <img style="height: 20px;padding: 0 8px;" v-if="showPhoneIcons" @click="setPhonePrefix('GLOBAL');userData.phone=''" src="/images/globe-earth-blue.png"/>
                </div>
              <input type="text" id="phone" class="form-control" name="phone"
                     placeholder="pl: +36201234567"
                     v-model="userData.phone"
                     v-bind:class="{ 'is-invalid' : error.phone }"
                     @focus="error.phone = null"
                     @keyup="checkPhone(userData.phone,$event)">
              </div>

              <small class="order-hint">{{ t.phone_hint }}</small>

              <p class="input-error-hint" v-if="error.phone" v-html="error.phone"></p>
            </div>

            <div class="custom-control custom-checkbox" v-if="!isUserLogged">
              <input type="checkbox" id="eula" class="custom-control-input" name="eula" v-on:change="error.eula = false" v-model="userData.eula">
              <label class="custom-control-label" for="eula" v-html="t.eula"></label>

              <p class="input-error-hint" v-if="error.eula" v-html="error.eula"></p>
            </div>

          </fieldset>

        </div>
        <div class="col-md-4" v-if="(type === '2' || type === undefined)">

          <fieldset>

            <legend class="mb-3">{{ t.contact_information }}</legend>

            <div class="form-group">
              <label class="control-label" for="email">{{ t.email }}*</label>
              <input type="text" id="email" class="form-control" name="email"
                     v-model="userData.email"
                     v-bind:class="{ 'is-invalid' : error.email }"
                     @click="setEmail()"
                     @focusout="emailFocusOut">

              <p class="input-error-hint" v-if="error.email" v-html="error.email"></p>
            </div>

            <div class="form-group" v-if="settingData.separatedName">
              <label class="control-label" for="last_name">{{ t.last_name }}*</label>
              <input type="text" id="last_name" class="form-control" name="last_name"
                     v-model="userData.last_name"
                     v-bind:class="{ 'is-invalid' : error.last_name }"
                     @focus="error.last_name = null">

              <p class="input-error-hint" v-if="error.last_name" v-html="error.last_name"></p>
            </div>

            <div class="form-group" v-if="settingData.separatedName">
              <label class="control-label" for="first_name">{{ t.first_name }}*</label>
              <input type="text" id="first_name" class="form-control" name="first_name"
                     v-model="userData.first_name"
                     v-bind:class="{ 'is-invalid' : error.first_name }"
                     @focus="error.first_name = null">

              <p class="input-error-hint" v-if="error.first_name" v-html="error.first_name"></p>
            </div>

            <div class="form-group" v-if="!settingData.separatedName">
              <label class="control-label" for="name">{{ t.name }}*</label>
              <input type="text" id="first_name" class="form-control" name="name"
                     v-model="userData.name"
                     v-bind:class="{ 'is-invalid' : error.name }"
                     @focus="error.name = null"
                     @change="setNames('NAME')">

              <p class="input-error-hint" v-if="error.name" v-html="error.name"></p>
            </div>

            <div class="form-group">
              <label class="control-label" for="phone">{{ t.phone }}*</label>
              <div class="d-flex">
                <div style="border: 1px solid #ced4da;" class="d-flex flex-column">
                  <img style="height: 35px;padding: 8px;" :src="phoneSrc" @click="showPhoneIcons = !showPhoneIcons;"/>
                  <img style="height: 20px;padding: 0 8px;" v-if="showPhoneIcons" @click="setPhonePrefix('HU');userData.phone='+36'" src="/images/hu.png" />
                  <img style="height: 20px;padding: 0 8px;" v-if="showPhoneIcons" @click="setPhonePrefix('GLOBAL');userData.phone=''" src="/images/globe-earth-blue.png"/>
                </div>
                <input type="text" id="phone" class="form-control" name="phone"
                       placeholder="pl: +36201234567"
                       v-model="userData.phone"
                       v-bind:class="{ 'is-invalid' : error.phone }"
                       @focus="error.phone = null"
                       @keyup="checkPhone(userData.phone,$event)"
                >
              </div>

              <small class="order-hint">{{ t.phone_hint }}</small>

              <p class="input-error-hint" v-if="error.phone" v-html="error.phone"></p>
            </div>

            <div class="custom-control custom-checkbox" v-if="!userIsLogged">
              <input type="checkbox" id="eula" class="custom-control-input" name="eula" v-on:change="error.eula = false" v-model="userData.eula">
              <label class="custom-control-label" for="eula" v-html="t.eula"></label>

              <p class="input-error-hint" v-if="error.eula" v-html="error.eula"></p>
            </div>

            <p><small v-html="t.required_fields"></small></p>
            <p v-if="!userData.user_is_logged" ><small v-html="t.customer_form_registration_text"></small></p>
            <button v-if="!userData.user_is_logged" id="show-login-modal" class="btn btn-primary-small" data-toggle="modal" data-target="#login-modal">{{ t.registration }} <i class="fa fa-arrow-right" aria-hidden="true"></i></button>

            <p class="recaptcha-hint"><small>This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
              <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</small></p>

          </fieldset>

        </div>
        <div class="col-md-3"></div>
        <div class="col-md-4">
          <fieldset>

            <legend class="mb-3">{{ t.invoice_detail }}</legend>

            <div class="form-group" v-if="formData.invoiceArray.length">
              <label class="control-label" for="invoice_id"><strong>{{ t.invoice_addresses }}</strong></label>
              <select id="invoice_id" class="form-control" name="invoice_id"
                      v-on:change="invoiceChange"
                      v-model="formData.invoiceAddress.invoice_id">
                <option value="0">{{ t.create_new_address }}</option>
                <option v-for="address in formData.invoiceArray" :key="address.id" :value="address.id">{{ address.name }}</option>
              </select>
            </div>

            <div class="">
              <label class="radio-container">
                <input type="radio" name="invoice_type" value="1"
                       v-model="formData.invoiceAddress.invoice_type"
                       @change="setInvoiceAddressType(1)"
                       :checked="formData.invoiceAddress.invoice_type === '1'">

                <span class="checkmark"></span> {{ t.invoice_personal }}
              </label>
            </div>

            <div class="">
              <label class="radio-container">
                <input type="radio" name="invoice_type" value="2"
                       v-model="formData.invoiceAddress.invoice_type"
                       @change="setInvoiceAddressType(2)"
                       :checked="formData.invoiceAddress.invoice_type === '2'">

                <span class="checkmark"></span> {{ t.invoice_company }}
              </label>
            </div>

            <div class="form-group" v-if="formData.countryArray.length">
              <label class="control-label" for="invoice_country">{{ t.invoice_country }}</label>
              <select id="invoice_country" class="form-control" name="invoice_country"
                      v-on:change="countryChange"
                      v-model="formData.invoiceAddress.invoice_country"
                      v-bind:class="{ 'is-invalid' : error.invoice_country }"
                      @focus="error.invoice_country = null">

                <option v-for="country in formData.countryArray" :key="country.id" :value="country.id">{{ country.name }}</option>
              </select>
            </div>

            <div class="form-group">
              <label class="control-label" for="invoice_name">{{ t.invoice_name }}*</label>
              <input type="text" id="invoice_name" class="form-control" name="invoice_name"
                     v-model="formData.invoiceAddress.invoice_name"
                     v-bind:class="{ 'is-invalid' : error.invoice_name }"
                     @focus="error.invoice_name = null"
                     @change="setNames('INVOICE')">

              <p class="input-error-hint" v-if="error.invoice_name" v-html="error.invoice_name"></p>
            </div>

            <div class="form-group" v-if="formData.invoiceAddress.invoice_type === '2' || formData.invoiceAddress.invoice_type === 2">
              <label class="control-label" for="invoice_tax">{{ t.invoice_tax_id }}*</label>
              <input type="text" id="invoice_tax" class="form-control" name="invoice_tax"
                     v-model="formData.invoiceAddress.invoice_tax_id"
                     v-bind:class="{ 'is-invalid' : error.invoice_tax_id }"
                     @focus="error.invoice_tax_id = null">

              <p class="input-error-hint" v-if="error.invoice_tax_id" v-html="error.invoice_tax_id"></p>
            </div>

            <div class="form-group">
              <label class="control-label" for="invoice_postal">{{ t.invoice_postal }}*</label>
              <input type="text" id="invoice_postal" class="form-control" name="invoice_postal"
                     v-on:change="postalChange"
                     v-model="formData.invoiceAddress.invoice_postal"
                     v-bind:class="{ 'is-invalid' : error.invoice_postal }"
                     @focus="error.invoice_postal = null">

              <p class="input-error-hint" v-if="error.invoice_postal" v-html="error.invoice_postal"></p>
            </div>

            <div class="form-group">
              <label class="control-label" for="invoice_city">{{ t.invoice_city }}*</label>
              <input type="text" id="invoice_city" class="form-control" name="invoice_city"
                     v-model="formData.invoiceAddress.invoice_city"
                     v-bind:class="{ 'is-invalid' : error.invoice_city }"
                     @focus="error.invoice_city = null">

              <p class="input-error-hint" v-if="error.invoice_city" v-html="error.invoice_city"></p>
            </div>

            <div class="form-group">
              <label class="control-label" for="invoice_address">{{ t.invoice_address }}*</label>
              <input type="text" id="invoice_address" class="form-control" name="invoice_address"
                     placeholder="pl: Kossuth utca 6."
                     v-model="formData.invoiceAddress.invoice_address"
                     v-bind:class="{ 'is-invalid' : error.invoice_address }"
                     @focus="error.invoice_address = null">

              <p class="input-error-hint" v-if="error.invoice_address" v-html="error.invoice_address"></p>
            </div>

            <div class="form-group">
              <label class="control-label" for="invoice_door">{{ t.invoice_door }}</label>
              <input type="text" id="invoice_door" class="form-control" name="invoice_door"
                     v-model="formData.invoiceAddress.invoice_door"
                     v-bind:class="{ 'is-invalid' : error.invoice_door }"
                     @focus="error.invoice_door = null">
            </div>

          </fieldset>

        </div>
        <div class="col-md-1"></div>
      </div>

    </form>

    <div class="webshop-step-holder">

      <div class="webshop-step-left">

        <div class="step-button" v-if="userData.user_is_logged">
          <router-link :to="{ name: 'Cart' }" class="btn btn-black-small text-red">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.cart }}
          </router-link>
        </div>

        <div class="step-button" v-if="!userData.user_is_logged">
          <router-link :to="{name: 'Cart' }" class="btn btn-black-small text-red">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.back }}
          </router-link>
        </div>

      </div>

      <div class="webshop-step-right" v-if="productData.products_count">
        <div class="step-button">
          <button class="btn btn-primary-small" v-on:click="saveCustomerForm">{{ t.next }} <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
        </div>
      </div>

    </div>

  </div>
</template>


<script>
import Vue from 'vue'
import {mapGetters} from "vuex";
import { VueReCaptcha } from 'vue-recaptcha-v3';
import axios from 'axios'
import { buildCartGtmItems, pushEcommerceEvent } from '../gtm'

export default {
  name: 'CustomerForm',
  computed: {
    ...mapGetters({
      t: "getLanguageData",
      error: "getErrorData",
      userData: "getUserData",
      productData: "getProductData",
      settingData: "getSettingData",
      formData: "getFormData",
      currentStep: "getCurrentStep",
      userIsLogged : "getUserIsLogged",
      orderData: "getOrderData",
      orderSummaryData: "getOrderSummaryData",
    }),
    type(){
      return this.$route.query.type
    }
  },
  data(){
    return {
      phoneSrc:'/images/hu.png',
      phoneType:'HU',
      showPhoneIcons: false,
      oldNumber:null,
      email:{
        beforeAt:true,
        click:0
      },
    };
  },
  methods: {
    pushBeginCheckoutEvent: function(){
      let orderHash = this.orderSummaryData && this.orderSummaryData.order_hash;
      let sessionKey = 'gtm_begin_checkout_sent_' + orderHash;

      if(!orderHash || sessionStorage.getItem(sessionKey)){
        return;
      }
      sessionStorage.setItem(sessionKey, '1');

      pushEcommerceEvent('begin_checkout', {
        currency: String(this.orderData.currencyCode).toUpperCase(),
        value: Number(this.productData.total.gross),
        items: buildCartGtmItems(this.productData.products),
      });
    },
    setInvoiceAddressType: function(type){
      this.formData.invoiceAddress.invoice_type = type;
      this.formData.invoiceAddress.invoice_tax_id = '';
    },
    setPhonePrefix: function(type){
      this.phoneSrc = type == 'HU'? '/images/hu.png': '/images/globe-earth-blue.png';
      this.phoneType = type == 'HU'? 'HU': 'OTHER';
      this.showPhoneIcons = false;
    },
    checkPhone: function(){
      var prefix = '+36';
      if(this.phoneType == 'HU') {
        if(this.userData.phone.includes(prefix)){
          this.oldNumber = this.userData.phone;
        }
        if(this.userData.phone==null || this.userData.phone=='' || !this.userData.phone.includes(prefix)){
          this.userData.phone = prefix;
        }else{
          this.userData.phone = this.oldNumber;
        }
      }
    },
    setNames: function(type = null){
      if(type=='NAME' && this.userData.name && !this.formData.invoiceAddress.invoice_name){
        this.formData.invoiceAddress.invoice_name = this.userData.name;
      }
      if(type=='INVOICE' && this.formData.invoiceAddress.invoice_name && !this.userData.name){
        this.userData.name = this.formData.invoiceAddress.invoice_name;
      }
      if(type == null && !this.userData.name && this.formData.invoiceAddress.invoice_name)
        this.userData.name = this.formData.invoiceAddress.invoice_name;

      if(type == null && this.userData.name && !this.formData.invoiceAddress.invoice_name)
        this.formData.invoiceAddress.invoice_name = this.userData.name;
    },
    emailFocusOut: function(){
      if(!this.userData.email.includes('@')){
        this.userData.email = this.userData.email +'@';
      }
      this.email.click=0;
    },
    setEmail: function(){
      if(!this.userData.email.includes('@')){
        this.userData.email = this.userData.email +'@';
      }
      if(this.email.click==0){
        this.email.click = 1;
        this.setCursorPosition(this.userData.email.search('@'));
      }
    },
    setCursorPosition: function(caretPos){
      var el = document.getElementById('email');
      el.focus();
      if(el.selectionStart==caretPos && this.userData.email != '@'){
        this.beforeAt = false;
      }else {
        el.setSelectionRange(caretPos, caretPos);
      }
    },
    /**
     * Adatok mentése
     */
    saveCustomerForm: function (){
      let $this = this;

      $this.$recaptcha("signup").then((token) => {
        let formData = {
          'g-recaptcha-response': token,
          'page'                : 'CustomerForm',
          'method'              : 'Save',
          'type'                : this.$route.query.type,
          'userData'            : $this.userData,
          'formData'            : $this.formData,
        };

        $this.$store.dispatch('setData', formData);
      });
    },
    invoiceChange: function (){
      let $addressId = this.formData.invoiceAddress.invoice_id;

      if(!$addressId){
        return true;
      }

      let $selectedAddress = this.getArrayItem(this.formData.invoiceArray, $addressId);

      if($selectedAddress !== null){
        if($selectedAddress.invoice_country)
          this.formData.invoiceAddress.invoice_country  = $selectedAddress.invoice_country;

        this.formData.invoiceAddress.invoice_name     = $selectedAddress.invoice_name;
        this.formData.invoiceAddress.invoice_postal   = $selectedAddress.invoice_postal;
        this.formData.invoiceAddress.invoice_city     = $selectedAddress.invoice_city;
        this.formData.invoiceAddress.invoice_address  = $selectedAddress.invoice_address;
        this.formData.invoiceAddress.invoice_door     = $selectedAddress.invoice_door;
        this.formData.invoiceAddress.invoice_tax_id   = $selectedAddress.invoice_tax_id;

        // Ha van Tax, akkor céges lesz!
        if($selectedAddress.invoice_tax_id){
          this.formData.invoiceAddress.invoice_type = '2';
        }

        this.$store.commit("setFormData",  this.formData);
      }else{
        this.formData.invoiceAddress.invoice_name     = '';
        this.formData.invoiceAddress.invoice_postal   = '';
        this.formData.invoiceAddress.invoice_city     = '';
        this.formData.invoiceAddress.invoice_address  = '';
        this.formData.invoiceAddress.invoice_door     = '';
        this.formData.invoiceAddress.invoice_tax_id   = '';
      }
    },
    countryChange: function(){
        this.formData.invoiceAddress.invoice_name     = '';
        this.formData.invoiceAddress.invoice_postal   = '';
        this.formData.invoiceAddress.invoice_city     = '';
        this.formData.invoiceAddress.invoice_address  = '';
        this.formData.invoiceAddress.invoice_door     = '';
        this.formData.invoiceAddress.invoice_tax_id   = '';
    },
    postalChange: function(){
        let $country = this.formData.invoiceAddress.invoice_country;
        let $postal = this.formData.invoiceAddress.invoice_postal;

        if(!$postal){
            return true;
        }

       let data = {
           country: $country,
           postal: $postal
       };

       let params = this.encodeQueryData(data);

       axios.get(this.settingData.postalUrl + '?' + params)
           .then((res) => {
                this.formData.invoiceAddress.invoice_city = res.data.city;
           })
           .catch((err) => {
               // eslint-disable-next-line
               console.error(err);
           });
    },
    // Segéd függvények
    getArrayItem: function ($addressArray, $addressId){
      for(let i in $addressArray){
        let item = $addressArray[i];
        if(item.id === $addressId){
          return item;
        }
      }
      return null;
    },
    encodeQueryData(data) {
        const ret = [];
        for (let d in data)
            ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
        return ret.join('&');
    },
  },
  created() {
    /** Ha üres a KOSÁR, akkor Cart-ra dobom! */
    if(!this.productData.products_count){
      this.$router.push({ name: 'Cart' });
      return;
    }

    this.pushBeginCheckoutEvent();

    /** ReCaptcha beállítás */
    Vue.use(VueReCaptcha, { siteKey: this.settingData.reCaptchaSiteKey })
    this.setNames();

    if(this.userData.phone == '' || this.userData.phone == null){
      this.userData.phone = '+36';
    }

    /** Ha a login-on megadta az email-t akkor azt beraktuk az URL-be és itt kivesszük onnan */
    if(this.$route.query.email){
      let email = this.$route.query.email;
      email = email.replace(' ','+');

      this.userData.email = email;
    }
    /** Set Step Indicator */
    this.$store.commit("setCurrentStep", 'Customer');
  },
  updated() {
    // Ha "saveCustomerForm" lefutott és minden rendben volt, akkor Step is változott, tehát haladunk előre...
    if(this.currentStep === 'Shipping'){
      this.$router.push({ name: 'Shipping' });
    }
  }
}
</script>
